import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MainApi from "../../../../../services/mainApi.service";
import { ITicketAutoInactiveRule } from "../../../../../models/ticket-auto-inactive-rule";
import { format } from "date-fns";
import { ptBR, enUS } from "date-fns/locale";

const TICKET_AUTO_INACTIVE_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketAutoInactiveRule/";
const TicketAutoInactiveRuleService = new MainApi<ITicketAutoInactiveRule>(
  TICKET_AUTO_INACTIVE_ROUTE
);

const translationPath = "page.settings.crm.ticketAutoInactivityRules.";

const TicketAutoInactiveRulesPage = () => {
  const navigate = useNavigate();

  const {
    t,
    i18n: { language },
  } = useTranslation();

  const columns: GridColDef<ITicketAutoInactiveRule>[] = [
    {
      field: "ticketChannel",
      headerName: t(translationPath + "ticket_channel") || "Board",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
    {
      field: "ticketChannelStep",
      headerName: t(translationPath + "ticket_channel_step") || "Board List",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
    {
      field: "minutes",
      headerName: t(translationPath + "minutes") || "Minutes",
      maxWidth: 100,
    },
    {
      field: "initialDate",
      headerName: t(translationPath + "initial_date") || "Initial date",
      maxWidth: 150,
      renderCell: (params) => {
        const date = new Date(params.value);
        return params.value
          ? format(date, "P", {
              locale: language === "pt-BR" ? ptBR : enUS,
            })
          : "-";
      },
    },
    {
      field: "endDate",
      headerName: t(translationPath + "end_date") || "End date",
      maxWidth: 150,
      renderCell: (params) => {
        const date = new Date(params.value);
        return params.value
          ? format(date, "P", {
              locale: language === "pt-BR" ? ptBR : enUS,
            })
          : "-";
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<ITicketAutoInactiveRule>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<ITicketAutoInactiveRule>
      showDefaultMacroFilters={false}
      service={TicketAutoInactiveRuleService}
      columns={columns}
      title={t(translationPath + "ticket_auto_inactivity_rules")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_ticket_auto_inactivity_rule") ||
        "Add Ticket Auto Inactive Rule"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default TicketAutoInactiveRulesPage;
